export const RETURN_PARAM = "from";

const PATH_LABELS = {
  "/dashboard": "Overview",
  "/dashboard/portfolios": "Debt Portfolios",
  "/dashboard/customers": "Customers",
  "/dashboard/cases": "Cases",
  "/dashboard/payments": "Payments",
  "/dashboard/reports": "Reports",
  "/dashboard/settings": "Settings",
};

export function isSafeReturnPath(path) {
  if (!path || typeof path !== "string") return false;
  const pathname = path.split("?")[0];
  return pathname.startsWith("/dashboard") && !path.includes("//") && !path.includes("://");
}

export function getReturnTarget(searchParams, fallback, locationState) {
  const fromState = locationState?.from;
  if (isSafeReturnPath(fromState)) return fromState;
  const from = searchParams.get(RETURN_PARAM);
  if (isSafeReturnPath(from)) return from;
  return fallback;
}

export function getReturnLabel(path) {
  if (!path) return "previous page";
  const pathname = path.split("?")[0];
  if (PATH_LABELS[pathname]) return PATH_LABELS[pathname];
  const segment = pathname.split("/").filter(Boolean).pop();
  if (!segment) return "previous page";
  return segment.replace(/-/g, " ");
}

function splitLocation(to) {
  const raw = String(to || "");
  const hashIndex = raw.indexOf("#");
  const hash = hashIndex >= 0 ? raw.slice(hashIndex) : "";
  const beforeHash = hashIndex >= 0 ? raw.slice(0, hashIndex) : raw;
  const queryIndex = beforeHash.indexOf("?");
  const pathname = queryIndex >= 0 ? beforeHash.slice(0, queryIndex) : beforeHash;
  const search = queryIndex >= 0 ? beforeHash.slice(queryIndex) : "";
  return { pathname, search, hash };
}

function returnState(location, existing) {
  const from = location ? `${location.pathname}${location.search || ""}` : null;
  const state = { ...(existing && typeof existing === "object" ? existing : {}) };
  if (isSafeReturnPath(from)) state.from = from;
  return state;
}

export function navigateWithReturn(navigate, to, location) {
  if (!navigate || !to) return;
  if (typeof to === "object") {
    navigate(to, { state: returnState(location, to.state || location?.state) });
    return;
  }
  const { pathname, search, hash } = splitLocation(to);
  navigate({ pathname, search, hash }, { state: returnState(location, location?.state) });
}

export function linkWithReturn(to, location) {
  if (to && typeof to === "object" && typeof to.pathname === "string") {
    return { ...to, state: returnState(location, to.state) };
  }
  const { pathname, search, hash } = splitLocation(to);
  return { pathname, search, hash, state: returnState(location) };
}
